import { createContext, use, type ReactNode } from 'react'
import { type CMSLayout } from '@/features/cms/components/CMS/types'

type Props = { data: CMSLayout['content_type_id']; children: ReactNode }

const CMSLayoutContext = createContext<CMSLayout['content_type_id'] | null>(null)

export const CMSLayoutContextProvider = ({ children, data }: Props) => {
  return <CMSLayoutContext value={data}>{children}</CMSLayoutContext>
}

export const useCMSLayoutContext = () => use(CMSLayoutContext)
